import { render, staticRenderFns } from "./default-result.vue?vue&type=template&id=60863f22"
import script from "./default-result.vue?vue&type=script&lang=js"
export * from "./default-result.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports